var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerizon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.825578, 0, 0, 0.825578, -79.426548, -79.451748)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.78,229.306h29.661v-54.187c0-12.36,7.225-21.107,17.872-21.107c10.267,0,15.591,7.227,15.591,17.495v57.8 h29.661v-63.503c0-21.488-12.928-36.699-33.844-36.699c-13.308,0-22.626,5.705-29.661,16.162h-0.571v-13.309h-28.71V229.306z M548.598,129.295c-30.993,0-51.716,22.246-51.716,51.527c0,29.092,20.724,51.528,51.716,51.528s51.716-22.436,51.716-51.528 C600.314,151.54,579.59,129.295,548.598,129.295z M548.408,210.483c-14.072,0-21.485-11.787-21.485-29.661 c0-18.063,7.413-29.662,21.485-29.662c14.069,0,21.865,11.598,21.865,29.662C570.273,198.696,562.477,210.483,548.408,210.483z M412.46,229.306h83.28v-23.385h-47.153v-0.573l45.062-50.576v-22.814H412.46v23.385h45.633v0.571L412.46,206.87V229.306z M374.429,229.306h29.851v-97.348h-29.851V229.306z M305.219,229.306h29.661v-44.68c0-20.346,12.169-29.283,30.802-26.81h0.571 v-25.668c-1.522-0.571-3.232-0.761-6.084-0.761c-11.598,0-19.394,5.323-26.05,16.731h-0.571v-16.16h-28.329V229.306z M250.651,210.675c-13.12,0-21.105-8.559-22.627-21.675h70.16c0.19-20.918-5.325-37.65-16.923-48.107 c-8.174-7.605-19.014-11.789-32.703-11.789c-29.279,0-49.625,22.246-49.625,51.337c0,29.28,19.394,51.716,51.527,51.716 c12.169,0,21.865-3.232,29.851-8.747c8.557-5.891,14.64-14.45,16.35-23.005h-28.519 C265.291,206.87,259.396,210.675,250.651,210.675z M249.129,150.399c10.457,0,17.682,7.798,18.823,19.205h-39.738 C230.497,158.004,236.77,150.399,249.129,150.399z M374.429,97.35h29.851v26.43h-29.851V97.35z",
    style: {
      fill: "rgb(245, 10, 35)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -1103.6993,
    cy: 2428.0923,
    r: 354.3687,
    gradientTransform: "matrix(0.0495 -0.1371 0.1483 0.0536 -145.6428 -68.8677)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5FF1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    style: {
      stopColor: "#F5FF1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    style: {
      stopColor: "#F5FA1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    style: {
      stopColor: "#F5A620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    style: {
      stopColor: "#F56321"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6779,
    style: {
      stopColor: "#F53322"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7657,
    style: {
      stopColor: "#F51523"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8155,
    style: {
      stopColor: "#F50A23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.201,228.095l-36.908-96.137H97.35l36.908,96.137c0.28,0.733,0.983,1.213,1.765,1.213h29.943 C165.184,229.308,164.481,228.828,164.201,228.095z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.787,228.095l36.908-96.137h29.943l-36.908,96.137c-0.28,0.733-0.983,1.213-1.765,1.213h-29.943 C136.805,229.308,137.508,228.828,137.787,228.095z",
    style: {
      fill: "rgb(245, 10, 35)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerizon);
export default __webpack_public_path__ + "static/media/verizon.6811e8c338ddad84685f9c374ffd946b.svg";
export { ForwardRef as ReactComponent };